import React from 'react'
import './StudentInstruction.scss'

export default function StudentInstruction(props) {
  return (
    <div 
      className='instruction-container' 
      style={{ height: props.fullHeight ? '100%' : 'auto', justifyContent: props.fullHeight ? 'flex-start' : 'center' }}>
        {props.children}
    </div>
  )
}
